module.exports = __webpack_public_path__ + "img/other.f32054ce.jpg";